import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import * as ExcelJS from 'exceljs';
import { LobI } from 'src/app/interfaces/lob.interface';
import { months } from 'src/app/interfaces/month.array';
import { LobService } from 'src/app/services/lob/lob.service';
import { DialogComponent } from '../dialog/dialog.component';
import { KmData, LobKm } from './models/lob.model';
import { RowComponent } from './rows/rows.component';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';
import { UserI } from 'src/app/interfaces/user.interface';
import { SectorI } from 'src/app/interfaces/segment-sector.interface';
import { KmShellI, KmType } from './models/km-shell.interface';
import { SectorService } from 'src/app/pages/home/sub-pages/sections/settings/settings-pages/sector-admin/sector.service';
import { firstValueFrom } from 'rxjs';
import { KmShellService } from '../../services/km-shell/km-shell.service';
import { yearList } from 'src/app/tools/tools';
import { Router } from '@angular/router';

@Component({
  selector: 'app-file-import',
  templateUrl: './file-import.component.html',
  styleUrls: ['./file-import.component.css'],
})
export class FileImportComponent {
  constructor(
    private readonly lobService: LobService,
    private readonly auth: AuthLoginService,
    private readonly sectorService: SectorService,
    private readonly kmShellService: KmShellService,
    private readonly router: Router,
    private cdr: ChangeDetectorRef
  ) {}

  lobs!: LobI[];
  user!: UserI | null;
  async ngOnInit() {
    const userState = await this.auth.returnUserInfoV2('LOADED');

    if (!userState) return;

    this.user = userState.user;

    this.lobService.getAll().subscribe((data) => {
      this.lobs = data.entities;
    });

    this.years = yearList(2019);
    this.selectedYear = this.years[this.years.length - 1];
  }

  @ViewChild('file') fileInput!: ElementRef<HTMLInputElement>;

  filename!: string;

  onFileChange(event: any): void {
    const file = event.target.files[0];
    const fileReader = new FileReader();
    this.filename = file.name;

    fileReader.onload = (e: any) => {
      const arrayBuffer = e.target.result;
      this.parseExcel(arrayBuffer);
    };

    fileReader.readAsArrayBuffer(file);
  }

  data!: KmData[];

  @ViewChild('dialog') dialog!: DialogComponent;

  parseExcel(arrayBuffer: any): void {
    this.data = [
      { tipo: 'KM', datos: [] },
      { tipo: 'Frenadas Bruscas', datos: [] },
    ];

    const items = ['KM', 'Frenadas Bruscas'];
    const workbook = new ExcelJS.Workbook();

    let i = 0;
    let subI = 0;
    workbook.xlsx.load(arrayBuffer).then((workbook) => {
      workbook.eachSheet((worksheet, sheetId) => {
        worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
          //* Cambiamos de planilla 0 == KM Shell | 1 == Frenadas Bruscas
          if (row.getCell(2).value == items[1]) i = 1;

          //! Lineas de negocio
          if (
            row.getCell(2).value != null &&
            row.getCell(3).value != null &&
            !items.includes(row.getCell(2).value as string)
          ) {
            this.data[i].datos.push({
              lob: row.getCell(2).value as string,
              selectedLob: undefined,
              sector: [],
              cantidades: [],
            });

            //* Obtenemos el índice actual
            subI = this.data[i].datos.length - 1;

            //* Recorremos las celdas siguientes
            for (let j = 1; j <= 12; j++) {
              //* Pusheamos los datos
              const h = j + 3;
              this.data[i].datos[subI].cantidades.push(
                row.getCell(h).result
                  ? row.getCell(h).result
                  : typeof row.getCell(h).value === 'number'
                  ? row.getCell(h).value
                  : 0
              );
            }
          }
          //! Sectores
          else if (
            row.getCell(3).value != null &&
            !items.includes(row.getCell(3).value as string)
          ) {
            this.data[i].datos[subI].sector.push({
              nombre: row.getCell(3).value as string,
              cantidades: [],
              selectedSector: undefined,
            });

            //* Obtenemos el índice actual
            const sectorI = this.data[i].datos[subI].sector.length - 1;

            //* Recorremos las celdas siguientes
            for (let j = 1; j <= 12; j++) {
              //* Pusheamos los datos
              const h = j + 3;
              this.data[i].datos[subI].sector[sectorI].cantidades.push(
                row.getCell(h).result
                  ? row.getCell(h).result
                  : typeof row.getCell(h).value === 'number'
                  ? row.getCell(h).value
                  : 0
              );
            }
          }
        });
      });
    });
  }

  @HostListener('window:drop', ['$event'])
  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const name = files[0].name.split('.');
      if (name[name.length - 1] == 'xlsx') {
        this.fileInput.nativeElement.files = files;
        this.filename = files[0].name;
        this.parseExcel(files[0]);
      }
    }
  }

  meses = months;

  @ViewChildren(RowComponent) rows!: QueryList<RowComponent>;
  upload() {
    this.dialog.confirm(
      '¿Está seguro/a de dar de alta los siguientes datos?',
      'Confirmación de carga',
      () => {
        this.onUpload();
      }
    );
  }
  async onUpload() {
    this.dialog.start();

    const newSectors: SectorI[] = [];

    const kmShell: KmShellI[] = [];

    let hasError = false;
    this.rows.forEach((r) => {
      //! Chequeamos que no tenga errores ----------------------------->
      const check = this.checkData(r.lob);
      if (!check) {
        r.showError();
        hasError = true;
      }
      //! Chequeamos que no tenga errores ----------------------------->

      //! Para que no haga trabajos en vano, cortamos el ciclo desde acá
      if (!hasError) {
        //* Creamos la lista de sectores nuevos: ------------------------>
        r.lob.sector.forEach((s) => {
          if (!s.selectedSector?.id) {
            if (s.selectedSector) newSectors.push(s.selectedSector);
          }
        });
        //* Creamos la lista de sectores nuevos: ------------------------>

        //* Creamos los items del km shell ------------------------------>

        r.lob.cantidades.forEach((c: number, i) => {
          const item: KmShellI = {
            type: r.tipo.toLowerCase() == 'km' ? KmType.km : KmType.frenadas,
            period: new Date(this.selectedYear.value, i, 1), //TODO Colocar un input para seleccionar el año
            value: [c],
            active: true,
            sectors: r.lob.sector
              .filter((s) => s.selectedSector !== undefined)
              .map((s) => {
                return {
                  sector: s.selectedSector as SectorI, // Aseguramos que selectedSector no es undefined
                  value: [s.cantidades[i]],
                };
              }),
            lob: r.lob.selectedLob!,
            user: this.user!,
          };
          kmShell.push(item); //? Pusheamos en la lista
        });
        //* Creamos los items del km shell ------------------------------>
      }
    });

    if (hasError)
      this.dialog.stop(
        'Faltan completar algunos campos.',
        'Error de carga',
        () => {},
        true
      );
    else {
      //* Insertamos los nuevos sectores
      const sectores = await this.insertSectors(newSectors);
      //! Caso que no haya nada que inserta, puede devolver *undefined*
      if (sectores) {
        //* Recorremos las planillas
        kmShell.forEach((kmShell) => {
          //* Dentro recorremos los sectores
          kmShell.sectors.forEach((kmS) => {
            //* Buscamos el nuevo sector
            const newSector = sectores.find((s) => s.name == kmS.sector.name);
            //* Y lo reemplazamos por el que se le hace referencia
            if (newSector) kmS.sector = newSector;
          });
        });
      }
      this.kmShellService.insert(kmShell).subscribe({
        next: (data) => {
          this.dialog.stop(
            'La planilla se cargo con éxito',
            'Confirmación de carga',
            () => {
              this.router.navigate(['/home/select-stats-form']);
            }
          );
        },
        error: (e) => {
          console.error(e);
          this.dialog.stop(
            'Ocurrió un error durante la carga',
            'Error de carga',
            () => {},
            true
          );
        },
      });
    }
  }

  async insertSectors(sectors: SectorI[]) {
    try {
      const s: SectorI[] = (await firstValueFrom(
        this.sectorService.insert(sectors)
      )) as SectorI[];
      return s;
    } catch (error) {
      console.error(error);
      this.dialog.stop(
        'Ocurrió un error durante la carga de los sectores',
        'Error de carga',
        () => {},
        true
      );
      throw new Error('Unable to insert sectors');
    }
  }

  years: {
    label: string;
    value: number;
  }[] = [];
  selectedYear!: {
    label: string;
    value: number;
  };

  checkData(lob: LobKm) {
    const hasUndefined = lob.sector.some((s) => s.selectedSector === undefined);
    if (hasUndefined || !lob.selectedLob) return false;
    else return true;
  }

  // Borra rows de la planilla --------------------->
  onDelete(data: { index: number; tipo: string }) {
    const tipo = this.data.find((d) => d.tipo == data.tipo);
    if (tipo) tipo.datos.splice(data.index, 1);
  }
  // Borra rows de la planilla --------------------->

  // Añade rows en la planilla --------------------->
  onAdd(tipo: string) {
    const cantidades = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
    const datos = { lob: '', selectedLob: undefined, cantidades, sector: [] };
    const data = this.data.find((d) => d.tipo == tipo);
    if (data) data.datos.push(datos);
    this.cdr.detectChanges();
  }
  // Añade rows en la planilla --------------------->

  // Carga manual ------------------>
  cargaManual() {
    this.data = [
      {
        tipo: 'KM',
        datos: [
          {
            lob: '',
            selectedLob: undefined,
            cantidades: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            sector: [],
          },
        ],
      },
      {
        tipo: 'Frenadas Bruscas',
        datos: [
          {
            lob: '',
            selectedLob: undefined,
            cantidades: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            sector: [],
          },
        ],
      },
    ];
  }
  // Carga manual ------------------>
}
